import { Component, forwardRef, OnInit } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { DocumentDao } from '@app/dao/document/document.dao';
import { GedService } from '@app/providers/ged/ged.service';
import { UserService } from '@app/providers/user/user.service';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { UserDao } from '../../../dao/user/user.dao';
import { EaJustifsFormBuilder } from './ea-justifs-form.builder';

@Component({
    selector: 'ea-justifs-form',
    templateUrl: './ea-justifs-form.component.html',
    styleUrls: ['./ea-justifs-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaJustifsFormComponent),
        },
    ],
    standalone: false
})
export class EaJustifsFormComponent
  extends EaJustifsFormBuilder
  implements OnInit
{
  files: File[] = [];
  file: any;
  error: string;
  user: UserAuthentified;
  doneSubject: Subject<void> = new Subject<void>();
  isCristalisOrganization: boolean = false;
  cristalisOrganizationId: number = 251251251;

  constructor(
    protected formConstructor: PrFormConstructor,
    private documentDao: DocumentDao,
    protected authenticationService: AuthentificationService,
    private userDao: UserDao,
    private gedService: GedService,
    private userService: UserService,
    private attributionDao: AttributionDao,
  ) {
    super(formConstructor, authenticationService);
  }

  ngOnInit() {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });

    combineLatest([
      this.userService.getUser(),
      this.userDao.getOwners(),
    ]).subscribe(([user, owners]) => {
      this.user = user;
      let item = this.extract().file;
      if (item != null) {
        if (
          item.type === 'application/pdf' ||
          item.type === 'image/jpeg' ||
          item.type === 'image/png' ||
          item.size < 20971520
        ) {
          this.files.push(item);
        }
        this.file = item;
      }
    });
  }

  onLoadFiles(files: any) {
    console.log('load file');

    this.files = files;
    if (this.files.length > 0) {
      this.error = null;
    }
  }

  get title() {
    return `Ajoutez votre ${this.entity?.file?.LibelleType}`;
  }

  onSubmit() {
    console.log('submit', this.entity);

    if (this.files.length === 0) {
      this.error = 'Veuillez saisir au moins un fichier';
    } else {
      //this.prFormService.loading();
      const formData = new FormData();
      for (const file of this.files) {
        formData.append('documentsFiles', file, file?.name);
      }

      const formValues = this.extract();
      delete formValues.file;

      formData.append(
        'document',
        new Blob([JSON.stringify(formValues)], {
          type: 'application/json',
        }),
      );

      console.log(formData);

      // this.documentDao.saveDocument(formData, formValues.accountId).subscribe(
      //   (success) => {
      //     this.gedService.saveOne(success);
      //     this.prFormService.loaded();
      //     this.doneSubject.next();
      //     this.notificationService.success("La sauvegarde a réussi");
      //   },
      //   (errors) => {
      //     console.error(errors);
      //     this.prFormService.loaded();
      //     this.notificationService.error("La sauvegarde a échoué");
      //   }
      // );
    }
  }
}
